<template>
    <router-view/>
</template>

<script>
export default {
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
        }
    },
    mounted(){
    },
    created(){
    },
    methods:{
    },
    components:{
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Layout.vue